import AnalyticsSection from '@/views/analytics/AnalyticsSection.vue';
import Analytics from '@/views/analytics/Analytics.vue';
import AnalyticCreate from '@/views/analytics/AnalyticCreate.vue';
import Analytic from '@/views/analytics/Analytic.vue';
import AnalyticDetails from '@/views/analytics/tabs/AnalyticDetails.vue';
import AnalyticDelete from '@/views/analytics/tabs/AnalyticDelete.vue';
import AnalyticEdit from '@/views/analytics/tabs/AnalyticEdit.vue';

export default [
  {
    path: '/analytics',
    component: AnalyticsSection,
    meta: {
      breadcrumb: {
        linkName: 'analytics.index',
        linkText: 'Analytics',
      },
    },
    children: [
      {
        path: '',
        component: Analytics,
        name: 'analytics.index',
      },
      {
        path: 'create',
        component: AnalyticCreate,
        name: 'analytics.index.create',
      },
      {
        path: ':id',
        component: Analytic,
        meta: {
          breadcrumb: {
            linkName: 'analytics.index.detail',
            linkText: 'Analytic Info',
          },
        },
        children: [
          {
            path: '',
            name: 'analytics.index.detail',
            component: AnalyticDetails,
            props: true,
          },
          {
            path: 'edit',
            name: 'analytics.index.detail.edit',
            component: AnalyticEdit,
            props: true,
          },
          {
            path: 'delete',
            name: 'analytics.index.detail.delete',
            component: AnalyticDelete,
            props: true,
          },
        ],
      },
    ],
  },
];
